<template>
  <div class="project_mng_content">
    <div class="w_d container">
      <div class="header_box">
        <MyNav2 :list="navArrVal" ref="childNav"></MyNav2>
        <div class="btn pointer" @click="lookMyClass">
          <span>直接看</span>
          <span class="fs20 ml6">{{ lookName }}</span>
        </div>
      </div>
      <!-- 主要内容 -->
      <section class="pd2430">
        <!-- 表单区域 -->
        <div class="project_search">
          <el-form :inline="true" :model="formData" class="demo-form-inline">
            <div>
              <!-- 请选择省份 -->
              <el-form-item class="adress">
                <el-select
                  v-model="formData.province"
                  placeholder="选择省份"
                  @change="getCityList"
                  clearable
                >
                  <el-option
                    :label="item.title"
                    :value="item.id"
                    v-for="(item, index) in provinceListArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 请选择城市 -->
              <el-form-item class="adress">
                <el-select
                  v-model="formData.city"
                  placeholder="选择城市"
                  @change="getareaList"
                  clearable
                >
                  <el-option
                    :label="item.title"
                    :value="item.id"
                    v-for="(item, index) in cityListArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 请选择区域 -->
              <el-form-item class="adress">
                <el-select
                  v-model="formData.area"
                  placeholder="选择区域"
                  clearable
                >
                  <el-option
                    :label="item.title"
                    :value="item.id"
                    v-for="(item, index) in areaListArr"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- 选择时间 -->
              <el-form-item>
                <el-date-picker
                  v-model="formData.time"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                >
                </el-date-picker>
              </el-form-item>
            </div>

            <!-- 选择项目级别 -->
            <el-form-item
              class="adress"
              v-if="
                path === '/tearcherMngProject' || path === '/ProjectMngStaff'
              "
            >
              <el-select
                v-model="formData.projectGrade"
                placeholder="选择项目级别"
                clearable
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="(item, index) in projectGrade"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 班级名称 -->
            <el-form-item class="project_name" v-else>
              <el-input
                v-model="formData.className"
                placeholder="请输入班级名称"
                clearable
              ></el-input>
            </el-form-item>
            <!-- 项目名称 -->
            <el-form-item class="project_name">
              <el-input
                v-model="formData.projectName"
                placeholder="请输入项目名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item class="btn_cls">
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
            <el-form-item v-if="path === '/MyMngClass'">
              <el-button type="primary" @click="exportClassDetail"
                >导出所选班级明细</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <!-- 排序 -->
        <div class="sort_box my_flex">
          <div class="sort_left">
            <ul class="flex_X">
              <li
                class="flex_X fs14"
                v-for="(item, index) in sortArrName"
                @click="sortSearch(index)"
                :class="{ pointer: index == 0 }"
              >
                <span>{{ item.name }}</span>
                <!-- 两个三角形 -->
                <div class="triangle_box" v-if="index != 0">
                  <div
                    class="up_triangle pointer"
                    :class="{ border_c: item.order == 1 }"
                    @click="ascendingSearch(index, item)"
                  ></div>
                  <div
                    class="down_triangle pointer"
                    :class="{ border_c: item.order == 2 }"
                    @click="descendingSearch(index, item)"
                  ></div>
                </div>
              </li>
            </ul>
          </div>
          <div class="sort_right">
            <!-- 筛选 -->
            <MyRadioGroup
              @changeRadioVal="changeRadioVal"
              :list="radioArrName"
              ref="radioChild"
            ></MyRadioGroup>
          </div>
        </div>
        <!-- 列表 -->
        <div v-if="total !== 0">
          <!-- 项目列表 -->
          <ul
            class="list"
            v-if="
              this.path == '/tearcherMngProject' ||
              this.path == '/ProjectMngStaff'
            "
          >
            <li class="fs12" v-for="(item, index) in MyProjectArr">
              <span class="fr">{{ item.status_name }}</span>
              <div class="circleBox">
                <el-progress
                  type="circle"
                  :percentage="Number(item.speed_progress)"
                  :show-text="false"
                  :width="92"
                  :stroke-width="2"
                ></el-progress>
                <div class="circleCenter fs14 bgc2">
                  <p class="c-main fw600 fs16">{{ item.speed_progress }}%</p>
                  <span class="c-999">项目进度</span>
                </div>
              </div>
              <p class="fs14 ellipsis_two mb14">{{ item.title }}</p>
              <div class="time c-666 pb10">
                <span>起止时间：</span>
                <span
                  >{{ item.start_date | filterYMD }} ~
                  {{ item.end_date | filterYMD }}</span
                >
              </div>
              <div class="row1 pb10">
                <span class="c-ccc">未开始班级数量：</span>
                <span>{{ item.status_no_start }}个</span>
                <span class="c-ccc">已结束班级数量：</span>
                <span>{{ item.status_end }}个</span>
              </div>
              <div class="row2 pb10">
                <span class="c-ccc">进行中班级数量：</span>
                <span>{{ item.status_starting }}个</span>
                <span class="c-ccc">已停用班级数量：</span>
                <span>{{ item.status_stop }}个</span>
              </div>
              <div class="row3">
                <span class="c-ccc">班级数量：</span>
                <span>{{ item.class_all }}个</span>
              </div>
              <div
                class="look_detail pointer"
                @click="lookProjectDetail(item.focus_project_id)"
              >
                查看详情
              </div>
            </li>
          </ul>
          <!-- 班级列表 -->
          <ClassList
            :list="MyProjectArr"
            :is_who="userInfo.type"
            v-else
          ></ClassList>
        </div>
        <Empty v-else></Empty>
        <!-- 分页 -->
        <Pagination
          :currentPage="currentPage"
          :pageSize="pageSize"
          :total="total"
          :selectSize="[8, 16, 24, 32]"
          @changePage="changePage"
          @changeSize="changeSize"
          v-if="total !== 0"
        ></Pagination>
      </section>
    </div>
  </div>
</template>

<script>
import {
  ProvinceListApi,
  CityListApi,
  MyProjectListApi,
  MyMngClass,
  AreaListApi,
} from "@/api/tearcher";
import {
  MngProjectList,
  AdministratorClassList,
  AdministratorMngClassExport,
} from "@/api/projectAdministrator";
import { filterYMD } from "@/filters";
export default {
  data() {
    return {
      navArr: [
        // {
        //   name: "我管理的远程项目",
        //   path: "",
        // },
        {
          name: "我管理的集中培训项目",
          path: "",
        },
      ],
      navArr2: [
        {
          name: "我管理的项目",
          path: "",
        },
      ],
      navArr3: [
        {
          name: "我管理的班级",
          path: "",
        },
      ],
      formData: {
        // projectName: "",
        // className: "",
      },
      sortArr: [
        {
          name: "默认排序",
          id: "",
          order: 0,
        },
        {
          name: "按时间",
          id: "",
          order: 0,
        },
        {
          name: "按班级数量",
          id: "",
          order: 0,
        },
      ],
      sortArr2: [
        {
          name: "默认排序",
          id: "",
          order: 0,
        },
        {
          name: "学员数",
          id: "",
          order: 0,
        },
        {
          name: "签到率",
          id: "",
          order: 0,
        },
        {
          name: "合格率",
          id: "",
          order: 0,
        },
        {
          name: "优秀率",
          id: "",
          order: 0,
        },
      ],
      radioArr: [
        {
          name: "全部",
          status: 0,
        },
        {
          name: "正常",
          status: 1,
        },
        {
          name: "已停用",
          status: 2,
        },
      ],
      // 1未开始 2进行中 3已结束 4已停用
      radioArr2: [
        {
          name: "全部",
          status: 0,
        },
        {
          name: "未开始",
          status: 1,
        },
        {
          name: "进行中",
          status: 2,
        },
        {
          name: "已结束",
          status: 3,
        },
        {
          name: "已停用",
          status: 4,
        },
      ],
      currentPage: 1, //当前页数
      pageSize: 8, // 当前页条数
      total: 11, // 总数
      MyProjectArr: [], // 项目列表
      path: "", //
      status: undefined, //1正常2停用
      order_time: undefined, //按时间 1 降序。2 升序
      order_class_num: undefined, //按班级数量 1 降序。2 升序
      provinceListArr: [], // 获取省列表
      cityListArr: [], // 获取市列表
      areaListArr: [], // 获取区列表
      //   project_level'项目级别 1校级 2区级 3市级 4省级 5国家级',
      projectGrade: [
        {
          name: "校级",
          id: 11,
        },
        {
          name: "区级",
          id: 12,
        },
        {
          name: "市级",
          id: 13,
        },
        {
          name: "省级",
          id: 14,
        },
        {
          name: "国家级",
          id: 15,
        },
      ], // 项目级别
      staff_num: undefined, //学员排序 1 降序 2 升序
      attendance_rate: undefined, //签到率 1 降序 2 升序
      qualified_rate: undefined, //合格率 1 降序 2 升序
      excellent_rate: undefined, //优秀率 1 降序 2 升序
    };
  },
  watch: {
    $route(to, from) {
      if (to.fullPath !== from.fullPath) {
        // 重置data数据
        Object.assign(this.$data, this.$options.data());
        this.path = to.fullPath;
        // 调用接口
        this.createFn();
      }
    },
  },
  methods: {
    // 导出所选班级的明细
    exportClassDetail() {
      if (this.total <= 0) {
        this.messageTips("暂无数据导出", "warning");
        return;
      }
      let time = this.formData.time;
      let start_date = undefined;
      let end_date = undefined;
      if (time) {
        start_date = filterYMD(time[0].getTime());
        end_date = filterYMD(time[1].getTime());
      }
      AdministratorMngClassExport({
        limit: this.pageSize,
        page: this.currentPage,
        user_id: this.userInfo.id,
        name: this.formData.className,
        title: this.formData.projectName,
        province_id: this.formData.province,
        city_id: this.formData.city,
        area_id: this.formData.area,
        start_date: start_date,
        end_date: end_date,
        status: this.status, //1正常2停用
        staff_num: this.staff_num, //  1 降序。2 升序
        attendance_rate: this.attendance_rate, //  1 降序。2 升序
        qualified_rate: this.qualified_rate, //  1 降序。2 升序
        excellent_rate: this.excellent_rate, //  1 降序。2 升序
      }).then((res) => {
        saveAs(res, "所选班级的明细.xls");
      });
    },
    // 查看
    lookMyClass() {
      if (this.path === "/tearcherMngClass") {
        // 班主任查看我管理的全部班级
        this.$router.push({
          path: "/tearcherMngProject",
        });
      } else if (this.path === "/tearcherMngProject") {
        // 班主任查看我管理的项目
        this.$router.push({
          path: "/tearcherMngClass",
        });
      } else if (this.path === "/ProjectMngStaff") {
        // 项目管理员查看我管理的项目
        this.$router.push({
          path: "/MyMngClass",
        });
      } else {
        // 项目管理员查看我管理的全部班级
        this.$router.push({
          path: "/ProjectMngStaff",
        });
      }
    },
    // 项目详情
    lookProjectDetail(projectId) {
      this.$router.push({
        path: "/ProjectDetail",
        query: { projectId: projectId },
      });
    },
    // 排序搜索
    sortSearch(index) {
      if (index === 0) {
        // 我管理的项目排序字段重置
        this.order_time = "";
        this.order_class_num = "";
        // 我管理的班级排序字段重置
        this.staff_num = "";
        this.attendance_rate = "";
        this.qualified_rate = "";
        this.excellent_rate = "";
        this.requestCommonFn();
      }
    },
    // 升序
    ascendingSearch(index, e) {
      if (this.path === "/tearcherMngClass" || this.path === "/MyMngClass") {
        // 我管理的班级
        this.sortArr2.map((o) => {
          // 先把所有的恢复初始状态
          o.order = 0;
        });
        // 先清空
        this.staff_num = "";
        this.attendance_rate = "";
        this.qualified_rate = "";
        this.excellent_rate = "";
        if (index === 1) {
          // 学员的升序
          this.staff_num = 2;
        } else if (index === 2) {
          // 签到率的升序
          this.attendance_rate = 2;
        } else if (index === 3) {
          // 合格率的升序
          this.qualified_rate = 2;
        } else if (index === 4) {
          // 优秀率的升序
          this.excellent_rate = 2;
        }
      } else if (
        this.path === "/tearcherMngProject" ||
        this.path === "/ProjectMngStaff"
      ) {
        // 我管理的项目
        this.sortArr.map((o) => {
          // 先把所有的恢复初始状态
          o.order = 0;
        });
        this.order_time = "";
        this.order_class_num = "";
        if (index === 1) {
          // 时间的升序
          this.order_time = 2;
        } else if (index === 2) {
          // 班级数量的升序
          this.order_class_num = 2;
        }
      }
      // 变颜色
      e.order = 1;
      this.requestCommonFn();
    },
    // 降序
    descendingSearch(index, e) {
      if (this.path === "/tearcherMngClass" || this.path === "/MyMngClass") {
        // 我管理的班级
        this.sortArr2.map((o) => {
          // 先把所有的恢复初始状态
          o.order = 0;
        });
        // 先清空
        this.staff_num = "";
        this.attendance_rate = "";
        this.qualified_rate = "";
        this.excellent_rate = "";
        if (index === 1) {
          // 学员的降序
          this.staff_num = 1;
        } else if (index === 2) {
          // 签到率的降序
          this.attendance_rate = 1;
        } else if (index === 3) {
          // 合格率的降序
          this.qualified_rate = 1;
        } else if (index === 4) {
          // 优秀率的降序
          this.excellent_rate = 1;
        }
      } else if (
        this.path === "/tearcherMngProject" ||
        this.path === "/ProjectMngStaff"
      ) {
        // 我管理的项目
        this.sortArr.map((o) => {
          // 先把所有的恢复初始状态
          o.order = 0;
        });
        this.order_time = "";
        this.order_class_num = "";

        if (index === 1) {
          // 时间的降序
          this.order_time = 1;
        } else if (index === 2) {
          // 班级数量的降序
          this.order_class_num = 1;
        }
      }
      // 变颜色
      e.order = 2;

      this.requestCommonFn();
    },
    // 根据省id获取市列表
    getCityList(val) {
      // 重置
      this.$set(this.formData, "city", "");
      this.$set(this.formData, "area", "");
      CityListApi(val).then((res) => {
        this.cityListArr = res.data;
      });
    },
    // 根据市id获取区列表
    getareaList(val) {
      // 重置
      this.$set(this.formData, "area", "");
      AreaListApi(val).then((res) => {
        this.areaListArr = res.data;
      });
    },
    // 我管理的项目
    requestCommonFn() {
      let time = this.formData.time;
      let start_date = undefined;
      let end_date = undefined;
      if (time) {
        start_date = filterYMD(time[0].getTime());
        end_date = filterYMD(time[1].getTime());
      }
      let projectTemp = {
        limit: this.pageSize,
        page: this.currentPage,
        user_id: this.userInfo.id,
        name: this.formData.projectName,
        level: this.formData.projectGrade,
        province_id: this.formData.province,
        city_id: this.formData.city,
        area_id: this.formData.area,
        start_date: start_date,
        end_date: end_date,
        status: this.status, //1正常2停用
        order_time: this.order_time, //  1 降序。2 升序
        order_class_num: this.order_class_num, //  1 降序。2 升序
      };
      let classTemp = {
        limit: this.pageSize,
        page: this.currentPage,
        user_id: this.userInfo.id,
        name: this.formData.className,
        title: this.formData.projectName,
        province_id: this.formData.province,
        city_id: this.formData.city,
        area_id: this.formData.area,
        start_date: start_date,
        end_date: end_date,
        status: this.status, //1正常2停用
        staff_num: this.staff_num, //  1 降序。2 升序
        attendance_rate: this.attendance_rate, //  1 降序。2 升序
        qualified_rate: this.qualified_rate, //  1 降序。2 升序
        excellent_rate: this.excellent_rate, //  1 降序。2 升序
      };
      if (this.path === "/tearcherMngProject") {
        // 班主任管理的项目
        MyProjectListApi(projectTemp).then((res) => {
          this.MyProjectArr = res.data.list;
          this.total = res.data.total;
        });
      } else if (this.path === "/tearcherMngClass") {
        // 班主任管理的班级
        MyMngClass(classTemp).then((res) => {
          this.MyProjectArr = res.data.list;
          console.log(this.MyProjectArr, "428");
          this.total = res.data.total;
        });
      } else if (this.path === "/ProjectMngStaff") {
        // 项目管理员管理的项目
        MngProjectList(projectTemp).then((res) => {
          this.MyProjectArr = res.data.list;
          this.total = res.data.total;
        });
      } else {
        // 项目管理员管理的班级
        AdministratorClassList(classTemp).then((res) => {
          this.MyProjectArr = res.data.list;
          this.total = res.data.total;
        });
      }
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 修改radioVal
    changeRadioVal(val) {
      this.status = val;
      this.requestCommonFn();
    },
    // 查询
    onSearch() {
      this.currentPage = 1;
      this.requestCommonFn();
    },
    // 重置
    onReset() {
      this.$set(this.formData, "projectName", "");
      this.$set(this.formData, "projectGrade", "");
      this.$set(this.formData, "province", "");
      this.$set(this.formData, "city", "");
      this.$set(this.formData, "area", "");
      this.$set(this.formData, "time", "");
      this.$set(this.formData, "className", "");
      // 恢复radio选中的项
      this.$refs.radioChild.radioVal = 0;

      this.status = "";
      // 我管理的项目排序字段重置
      this.order_time = "";
      this.order_class_num = "";
      // 我管理的班级排序字段重置
      this.staff_num = "";
      this.attendance_rate = "";
      this.qualified_rate = "";
      this.excellent_rate = "";
      this.requestCommonFn();
    },
    createFn() {
      //   this.path = this.$route.path;
      //   console.log(this.path,'446');
      // 列表
      this.requestCommonFn();
      // 获取省列表
      ProvinceListApi().then((res) => {
        this.provinceListArr = res.data;
      });
    },
  },
  computed: {
    navArrVal() {
      return this.path == "/tearcherMngProject"
        ? this.navArr2
        : this.path == "/tearcherMngClass" || this.path == "/MyMngClass"
        ? this.navArr3
        : this.navArr;
    },
    lookName() {
      return this.path == "/tearcherMngProject"
        ? "我管理的班级"
        : this.path == "/tearcherMngClass"
        ? "我管理的项目"
        : this.path == "/MyMngClass"
        ? "我管理的集中培训项目"
        : "我管理的班级";
    },
    sortArrName() {
      return this.path == "/tearcherMngProject" ||
        this.path == "/ProjectMngStaff"
        ? this.sortArr
        : this.path == "/tearcherMngClass" || this.path == "/MyMngClass"
        ? this.sortArr2
        : "";
    },
    radioArrName() {
      return this.path == "/tearcherMngProject" ||
        this.path == "/ProjectMngStaff"
        ? this.radioArr
        : this.path == "/tearcherMngClass" || this.path == "/MyMngClass"
        ? this.radioArr2
        : "";
    },
  },
  created() {
    this.path = this.$route.path;
    // console.log(this.$route, "446");
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.project_mng_content {
  background-color: #f7f7f7;
  padding: 25px 0 50px;
  .container {
    background-color: #fff;
    padding-bottom: 100px;
    padding: 0;
    .header_box {
      position: relative;
      .btn {
        width: auto;
        height: 40px;
        line-height: 40px;
        position: absolute;
        padding: 0 10px;
        top: 7px;
        right: 24px;
        span {
          &:nth-child(2) {
            font-weight: 600;
            /* margin-left: 20px; */
          }
        }
      }
    }
    .project_search {
      /deep/ .el-form {
        .el-form-item {
          margin-right: 24px;
        }
        .adress {
          .el-input__inner {
            width: 168px;
          }
        }
        .project_name {
          .el-input__inner {
            width: 360px;
          }
        }
      }
    }
    .sort_box {
      border: 1px solid #f0f0f0;
      margin-top: 24px;
      padding: 0 24px;
      height: 56px;
      .sort_left {
        ul {
          li {
            position: relative;
            border-right: 1px solid #b9b9b9;
            height: 12px;
            line-height: 12px;
            padding: 0 35px;
            &:nth-child(1) {
              padding-left: 0;
            }
            &:last-child {
              padding-right: 0;
              border-right: none;
            }
            .triangle_box {
              margin-left: 5px;
              .up_triangle {
                width: 0;
                height: 0;
                border-width: 4px;
                border-style: solid;
                border-color: transparent transparent #c3ccd9 transparent;
                margin-bottom: 2px;
                &.border_c {
                  border-color: transparent transparent #3489ff transparent;
                }
              }
              .down_triangle {
                width: 0;
                height: 0;
                border-width: 4px;
                border-style: solid;
                border-color: #c3ccd9 transparent transparent transparent;
                &.border_c {
                  border-color: #3489ff transparent transparent transparent;
                }
              }
            }
            .line {
              position: absolute;
              top: 0;
              right: 0;
            }
          }
        }
      }
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      padding: 24px 0;
      li {
        width: 276px;
        padding: 22px 16px;
        margin-right: 16px;
        border-radius: 2px;
        margin-bottom: 24px;
        box-shadow: 0 0 12px #ccc;
        &:nth-child(4n) {
          margin-right: 0;
        }
        > p {
          text-align: center;
          height: 60px;
          padding: 18px 0 0px;
        }
        .circleBox {
          position: relative;
          text-align: center;
          width: 92px;
          height: 92px;
          margin: 24px auto 0;
          .circleCenter {
            width: 80%;
            height: 80%;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            border-radius: 50%;
            padding-top: 20px;
          }
        }
        .time {
          text-align: center;
        }
        .row1,
        .row2,
        .row3 {
          span {
            &:nth-child(2) {
              margin-right: 14px;
            }
          }
        }
        .look_detail {
          margin-top: 24px;
          width: 100%;
          height: 30px;
          line-height: 30px;
          border: 1px solid #ccc;
          border-radius: 2px;
          text-align: center;
          font-size: 14px;
          text-align: center;
          &:hover {
            background-color: #3489ff;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
